import { COLORS, RADIUS, fontFamilyFor } from "../../../theme";

export const Style = {
  heading: (isArabic) => ({
    fontFamily: isArabic ? fontFamilyFor("ar") : "'Playfair Display', serif",
    color: COLORS.white,
    fontSize: "22px",
    fontStyle: "normal",
    fontWeight: "700",
    lineHeight: "normal",
  }),
  para: (isArabic) => ({
    height: "37px",
    flexShrink: "0",
    color: "rgba(255,255,255,0.55)",
    textalign: "center",
    fontFamily: fontFamilyFor(isArabic ? "ar" : "en"),
    fontSize: { xs: "14px", sm: "16px" },
    fontstyle: "normal",
    fontweight: "400",
    lineheight: "normal",
    margin: "10px 0 14px",
  }),
  allTickets: {
    width: "100%",
    padding: "10px 0",
    boxSizing: "border-box !important",
    flexWrap: "wrap",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  // `src` kept in the signature (still passed from index.jsx) but unused —
  // the new design uses flat tier cards, not a background-image ticket stub.
  ticket: (src, isArabic) => ({
    width: "100%",
    background: COLORS.gray,
    border: "1px solid rgba(255,255,255,0.08)",
    borderRadius: RADIUS.card,
    display: "flex",
    flexDirection: isArabic ? "row-reverse" : "row",
    justifyContent: "space-between",
    alignItems: "center",
    textAlign: "start",
    boxSizing: "border-box !important",
    padding: "18px 20px",
    margin: "3px 0",
    color: COLORS.white,
    transition: "border-color 0.2s ease",
    "&:hover": { borderColor: COLORS.gold },
  }),
  ticketInfoBox: (isArabic) => ({
    display: "flex",
    flexDirection: isArabic ? "row-reverse" : "row",
    alignItems: "center",
    gap: "20px !important",
  }),
  ticketTypeBox: {
    display: "flex",
    alignItems: "center",
    gap: "2px",
  },
  ticketType: (isArabic) => ({
    fontFamily: fontFamilyFor(isArabic ? "ar" : "en"),
    color: COLORS.white,
    fontSize: "15px",
    fontStyle: "normal",
    fontWeight: "700",
    lineHeight: "normal",
  }),
  info: {
    color: "rgba(255,255,255,0.4)",
  },
  avail: {
    color: COLORS.white,
    fontFamily: "'Outfit', sans-serif",
    fontSize: "10px",
    fontStyle: "normal",
    fontWeight: "600",
    lineHeight: "normal",
    padding: "3px 0",
  },
  priceBox: (isArabic) => ({
    display: "flex",
    alignItems: "end",
    fontSize: "13px",
    color: COLORS.gold,
    fontFamily: fontFamilyFor(isArabic ? "ar" : "en"),
    fontStyle: "normal",
    fontWeight: "600",
    lineHeight: "normal",
    gap: "5px",
  }),
  price: (isArabic) => ({
    color: COLORS.gold,
    fontFamily: fontFamilyFor(isArabic ? "ar" : "en"),
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: "700",
    lineHeight: "normal",
  }),
  numBox: (isArabic) => ({
    display: "flex",
    flexDirection: isArabic ? "row-reverse" : "row",
    alignItems: "center",
    gap: "8px",
  }),
  remove: {
    background: "rgba(255,255,255,0.1)",
    color: COLORS.white,
    borderRadius: "100%",
    fontSize: "19px",
    padding: "2px",
    cursor: "pointer",
  },
  add: {
    color: COLORS.peach,
    cursor: "pointer",
  },
  button: (isArabic) => ({
    background: COLORS.peach,
    color: COLORS.dark,
    position: { xs: "absolute", sm: "static" },
    width: { xs: "calc(100% - 40px)", sm: "100%" },
    bottom: "20px",
    left: "20px",
    display: "flex",
    flexDirection: isArabic ? "row-reverse" : "row",
    justifyContent: "space-between",
    maxWidth: { xs: "600px", sm: "335px" },
    height: "60px",
    flexShrink: "0",
    borderRadius: RADIUS.pill,
    boxShadow: "0 12px 34px rgba(212,175,55,0.25)",
    boxSizing: "border-box",
    "&:hover": { background: COLORS.gold },
  }),
  buttonHead: {
    fontFamily: "'Playfair Display', serif",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: "700",
    lineHeight: "normal",
  },
  buttonPrice: (isArabic) => ({
    textAlign: "right",
    fontFamily: fontFamilyFor(isArabic ? "ar" : "en"),
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "normal",
  }),
};
